export default __webpack_public_path__ + "images/arrow-right-his_30e9d9.svg";